import { useQuery } from "@/api/swr/useQuery";
import { companySchema } from "@/schema/console/companies/Company";
import { z } from "zod";

const companiesSchema = z.array(companySchema);

type Config = Parameters<typeof useQuery<typeof companiesSchema>>[2];

export function useGetCompanies(config?: Config) {
  return useQuery(companiesSchema, "/console/companies", config);
}
